import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/tab';
import 'imagesloaded';
import 'bootstrap-select';
import 'jquery-match-height';
import 'cookieconsent';
import 'slick-carousel';

import './parts/header';
import './parts/base';
import './parts/slick';


// WEBPACK FOOTER //
// ./js/main.js